module.exports = __webpack_public_path__ + "static/media/e65f2db8-fd7c-4229-a9fe-e9a29468e365.47d77cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/certificate-img/completion/e65f2db8-fd7c-4229-a9fe-e9a29468e365.png
// module id = 1485
// module chunks = 0